/* External */
import React from 'react';
import PropTypes from 'prop-types';

function MiniEpgErrorMessage({ message }) {
  return (
    <div>
      <p>{message}</p>
    </div>
  );
}

MiniEpgErrorMessage.propTypes = {
  message: PropTypes.string,
};

MiniEpgErrorMessage.defaultProps = {
  message: '',
};

export default MiniEpgErrorMessage;
